import Api from '../abstract';

export let CREATE = (params, successCallback, errorCallback) => {
    let url = `/user/link-kintone/setting`;
    let data = params.payload.data;
    return Api.post(url, data).then(successCallback).catch(errorCallback);
};

export let LIST = (params, successCallback, errorCallback) => {
    let url = `/user/link-kintone/setting?${params.payload.query}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let DETAIL = (params, successCallback, errorCallback) => {
    let url = `/user/link-kintone/setting/${params.payload.id}`;
    return Api.get(url).then(successCallback).catch(errorCallback);
};

export let UPDATE = (params, successCallback, errorCallback) => {
    let url = `/user/link-kintone/setting/${params.payload.id}`;
    let data = params.payload.data;
    return Api.put(url, data).then(successCallback).catch(errorCallback);
};

export let UPDATE_NOTES = (params, successCallback, errorCallback) => {
  let url = `/user/link-kintone/setting/${params.payload.id}/updateNotes`;
  let data = params.payload.data;
  return Api.put(url, data).then(successCallback).catch(errorCallback);
};

export let DELETE = (params, successCallback, errorCallback) => {
    let url = `/user/link-kintone/setting/${params.payload.id}`;
    return Api.delete(url).then(successCallback).catch(errorCallback);
};

export let TOOGLE_STATUS = (params, successCallback, errorCallback) => {
    let url = `/user/link-kintone/setting/${params.payload.id}`;
    return Api.patch(url).then(successCallback).catch(errorCallback);
};

export let UPDATE_JOB = (params, successCallback, errorCallback) => {
    let url = `/user/link-kintone/setting/${params.payload.id}/updateJob`;
    return Api.patch(url).then(successCallback).catch(errorCallback);
};
